import React, { useState, useRef, useEffect } from 'react';
import './Dropdown.css';

function Dropdown({ trigger, children, align = 'right' }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="ui-dropdown" ref={dropdownRef}>
      <div onClick={() => setIsOpen(!isOpen)} className="ui-dropdown__trigger">
        {trigger}
      </div>
      {isOpen && (
        <div className={`ui-dropdown__menu ui-dropdown__menu--${align}`}>
          {React.Children.map(children, child => {
            if (!React.isValidElement(child)) return null;
            // Don't add onClick to decorative elements (hr, p used as separators/labels)
            const tag = child.type;
            if (tag === 'hr' || tag === 'p') return child;
            return React.cloneElement(child, {
              onClick: (e) => {
                if (child.props.onClick) child.props.onClick(e);
                setIsOpen(false);
              }
            });
          })}
        </div>
      )}
    </div>
  );
}

export function DropdownItem({ icon, children, onClick }) {
  return (
    <button className="ui-dropdown__item" onClick={onClick}>
      {icon && <span className="ui-dropdown__item-icon">{icon}</span>}
      <span className="ui-dropdown__item-text">{children}</span>
    </button>
  );
}

export default Dropdown;
